<template>
    <span class="data-value copy-element">
        <CompassLink :label="email" link="javascript:;" @click="emailClicked">
            <slot />
        </CompassLink>
        <SaasClipboard v-if="email" :data="email" />
    </span>
</template>

<script>
import EmailMixins from 'mixins/EmailMixins';
import Feature from 'Services/Feature';
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';

export default {
    components: {
        SaasClipboard,
    },
    mixins: [EmailMixins],
    props: {
        email: {
            type: String,
            default: '',
        },
        linkedtype: {
            type: String,
            required: true,
        },
        linkedid: {
            type: Number,
            required: true,
        },
    },
    methods: {
        emailClicked() {
            if (!this.disabled) {
                const prefill =
                    Feature.isEnabled('email-engine') && !this.email ? { checkPrefill: true } : {};
                this.checkEmailProvider({}, prefill, this.email);
            }
        },
    },
};
</script>
